import { Menu, Pencil, Check, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Dashboard } from '../../types/analytics.types';

interface DashboardHeaderProps {
  dashboard: Dashboard | null;
  isEditMode: boolean;
  hasUnsavedChanges: boolean;
  onToggleSidebar: () => void;
  onToggleEditMode: () => void;
  onSaveLayout: () => void;
  onDiscardLayout: () => void;
}

export function DashboardHeader({
  dashboard,
  isEditMode,
  hasUnsavedChanges,
  onToggleSidebar,
  onToggleEditMode,
  onSaveLayout,
  onDiscardLayout,
}: DashboardHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-2 px-4 pb-2 pt-4 md:px-8 md:pt-8">
      <div className="flex items-center gap-2 md:gap-4 min-w-0">
        <Button variant="ghost" size="icon" onClick={onToggleSidebar}>
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle sidebar</span>
        </Button>
        <h1 className="text-xl md:text-2xl font-semibold tracking-tight truncate">
          {dashboard?.name || 'Dashboard'}
        </h1>
      </div>
      {/* Layout editing is drag/resize based; the phone view is a fixed stack. */}
      <div className="hidden md:flex items-center gap-2 shrink-0">
        {isEditMode && hasUnsavedChanges ? (
          <>
            <Button variant="outline" size="sm" onClick={onDiscardLayout}>
              <X className="mr-2 h-4 w-4" />
              Discard
            </Button>
            <Button size="sm" onClick={onSaveLayout}>
              <Check className="mr-2 h-4 w-4" />
              Save Layout
            </Button>
          </>
        ) : (
          <Button
            variant={isEditMode ? 'secondary' : 'outline'}
            size="sm"
            onClick={onToggleEditMode}
          >
            <Pencil className="mr-2 h-4 w-4" />
            {isEditMode ? 'Done Editing' : 'Edit Layout'}
          </Button>
        )}
      </div>
    </div>
  );
}
